<template>
  <header class="header-css">
    <div class="container">
      <div class="row" id="first-line-header">
        <div class="col-lg-auto" id="first-line-left-block">
          <div class="row ">
            <div class="header-address-block-inner header-first-line-item col-md-auto" id="header-address-block-address">
              <div
                  class="row row-container-item-header nowrap"
                  v-if="siteCustomizationData.headerFooter.address !== ''"
              >
                <div class="header-item-icon">
                  <svg  preserveAspectRatio="xMidYMid meet" id="comp-kaehbr4hsvgcontent" data-bbox="42 20.5 116 159" viewBox="42 20.5 116 159" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img">
                    <g>
                      <path d="M99.999 179.5l-4.053-4.877C93.746 171.972 42 109.349 42 78.612 42 46.569 68.018 20.5 99.999 20.5 131.985 20.5 158 46.569 158 78.612c0 30.738-51.743 93.361-53.948 96.011l-4.053 4.877zm0-148.434c-26.166 0-47.455 21.328-47.455 47.545 0 20.481 31.206 63.869 47.455 84.264 16.252-20.394 47.458-63.783 47.458-84.264-.001-26.217-21.289-47.545-47.458-47.545z" fill="#4854C7" data-color="1"></path>
                      <path d="M99.999 102.075c-12.911 0-23.419-10.525-23.419-23.464s10.507-23.466 23.419-23.466c12.914 0 23.421 10.527 23.421 23.466 0 12.939-10.507 23.464-23.421 23.464zm0-36.364c-7.097 0-12.872 5.786-12.872 12.9 0 7.112 5.775 12.899 12.872 12.899 7.1 0 12.878-5.787 12.878-12.899-.001-7.114-5.779-12.9-12.878-12.9z" fill="#4854C7" data-color="1"></path>
                    </g>
                  </svg>
                </div>
                <div id="header-address">
                  {{ siteCustomizationData.headerFooter.address }}
                </div>
              </div>
            </div>
            <div class="header-address-block-inner header-first-line-item col-md-auto" id="header-address-block-phone">
              <div
                  class="row row-container-item-header nowrap"
                  v-if="siteCustomizationData.headerFooter.phone !== ''"
              >
                <svg class="header-item-icon" preserveAspectRatio="xMidYMid meet" id="comp-kaehivuzsvgcontent" data-bbox="23.5 23.5 153 152.999" viewBox="23.5 23.5 153 152.999" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img">
                  <g>
                    <path d="M57.671 34.013c2.802 0 5.998 1.02 8.46 4.693 6.633 9.883 13.03 19.193 16.572 25.532 1.199 2.151 2.363 8.239-1.553 12.646-3.381 3.798-6.364 4.73-8.165 7.504-1.235 1.912-2.646 6.184-.325 11.096 2.776 5.867 6.162 10.685 13.592 18.234 7.547 7.421 12.364 10.804 18.242 13.581 1.918.905 3.742 1.241 5.363 1.241 2.532 0 4.574-.816 5.735-1.566 2.776-1.799 3.71-4.78 7.511-8.161 2.292-2.033 5.034-2.696 7.443-2.696 2.231 0 4.177.57 5.207 1.148 6.342 3.536 15.657 9.931 25.549 16.558 6.938 4.649 4.408 11.913 3.431 14.196-.982 2.284-6.004 9.841-16.805 15.491-2.972 1.553-6.893 2.476-11.648 2.476-14.968 0-38.155-9.16-65.66-36.651-36.237-36.217-40.635-64.946-34.188-77.26 5.651-10.798 13.213-15.818 15.5-16.795 1.074-.462 3.25-1.267 5.739-1.267zm0-10.513c-4.111 0-7.658 1.158-9.908 2.13-4.45 1.896-13.862 8.598-20.651 21.572-8.484 16.206-4.132 49.387 36.071 89.566 34.585 34.568 60.642 39.731 73.097 39.731 6.301 0 11.86-1.237 16.522-3.674 12.956-6.777 19.673-16.176 21.598-20.661 4.489-10.497 1.645-21.118-7.239-27.075-1.525-1.02-3.036-2.035-4.522-3.034-8.235-5.536-16.013-10.766-21.758-13.972-2.808-1.57-6.577-2.477-10.331-2.479-5.495 0-10.484 1.848-14.427 5.348-2.618 2.327-4.251 4.482-5.442 6.054-.246.325-.552.73-.788 1.02h-.033c-.247 0-.54-.078-.87-.234-4.366-2.062-8.274-4.609-15.298-11.51-6.908-7.024-9.456-10.928-11.519-15.292-.191-.403-.24-.699-.237-.9.29-.235.698-.543 1.025-.79 1.574-1.191 3.729-2.82 6.053-5.43 6.654-7.492 6.45-18.339 2.884-24.745-3.234-5.787-8.505-13.615-14.088-21.903-.968-1.439-1.953-2.899-2.942-4.374C70.824 26.82 64.717 23.5 57.671 23.5z" fill="#4854C7" data-color="1"></path>
                  </g>
                </svg>
                <div class="phone-inner">
                  <div id="header-phone">
                    {{ siteCustomizationData.headerFooter.phone }}
                  </div>
                </div>
              </div>
            </div>
            <div id="continer-sign-up">

            </div>
          </div>
        </div>
        <div class="col-lg header-first-line-item" id="first-line-central-block">
          <social-menu/>
        </div>
        <div class="col-lg-auto header-first-line-item" id="first-line-right-block">
          <sign-up-menu/>
        </div>
      </div>
    </div>
    <div id="central-button-header-block">
      <css-button />
      <div class="col-lg header-first-line-item" id="central-line-central-block">
        <social-menu/>
      </div>
    </div>
    <div id="container-scc-navbar">
      <b-navbar toggleable="xl" class="container" id="scc-navbar">
        <b-navbar-brand :to="{name: 'home'}">
          <img class=' image rounded' id="logo-header" :src="uriLogo">
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse">
          <span><font-awesome-icon :icon="['fa', 'bars']" /></span>
        </b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto navbar-collapse" id="navbarText">
            <top-nav-menu/>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </header>
</template>

<script>
import TopNavMenu from "./topNavMenu";
import SignUpMenu from "./signUpMenu";
import SocialMenu from "./socialMenu";
import cssButton from "../elements/cssButton";
import {mapState} from "vuex";

export default {
  name: "headerScc",
  components: {TopNavMenu, SignUpMenu, SocialMenu, cssButton,},
  data(){
    return {
      uriLogo: require("../../assets/logoHeader/company_logo.png"),
    }
  },
  computed : {
    ...mapState({
      siteCustomizationData: state => state.settingsAndCustomize.siteCustomizationData,
      configurationSite: state => state.settingsAndCustomize.configurationSite,
      cacheData: state => state.settingsAndCustomize.siteCustomizationData.hash,
})
  },
  mounted: function() {
    let customFavicon = document.querySelector(
        `head > link[rel='icon']`
    );
    customFavicon.href = this.$store.getters["settingsAndCustomize/configurationSite"].urlSite
        + 'img/system/favicon'
        + '_' + this.$store.getters["settingsAndCustomize/hash"]
        + '.ico'

    this.uriLogo = this.$store.getters["settingsAndCustomize/configurationSite"].urlSite
        + 'img/system/company_logo'
        + '_' + this.$store.getters["settingsAndCustomize/hash"]
        + '.png'
  },
  methods:{

  }
}
</script>

<style scoped>
.header-css{
  position: relative;
  border-bottom: 1px solid rgba(255,255,255,.2);
  box-shadow: 0px 5px 30px 0px rgb(136 136 136 / 25%);
  background: #fff;
  flex-grow: 0;
  z-index: 102;
}
#scc-navbar{
  padding-bottom: 0;
}
.header-first-line-item{
  margin-bottom: 5px;
  margin-top: 5px;
}
#first-line-left-block{
  width: 520px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
#first-line-central-block{
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
#first-line-right-block{
  width: 520px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}
.phone-inner{
  position: relative;
}
.span-header-phone {
  display: inline;
}
.header-first-line-item{
  margin-bottom: 5px;
  margin-top: 5px;
}
#first-line-header{
  padding: 7px 15px;
  justify-content: space-between
}

#first-line-left-block{
  width: 400px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding-left: 0;
}
#first-line-central-block{
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
#first-line-right-block{
  width: 400px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding-right: 0;
}
.phone-inner{
  position: relative;
}
.span-header-phone {
  display: inline;
}
#header-social-icons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
#header-address-block-address,
#header-address-block-phone{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.header-item-icon{
  padding-right: 7px;
  font-size: 18px;
  fill: var(--ButtonColor);
  width: 27px;
  height: 20px;
}
.header-item-icon path{
  fill: var(--ButtonColor);
}
.header-address-block-inner{
  font-size: 14px;
  color: var(--BasicFontColor);
}
#header-address {
  max-width: 190px;
  text-align: start;
}
#header-phone{
  max-width: 90px;
  text-align: start;
}
.phone-inner a{
  color: #525252;
  text-decoration: none;
}
#first-line-central-block a,
#central-line-central-block a{
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background-color: #adb5bd;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  margin-left: 10px;
}
#first-line-central-block  a .fa,
#first-line-central-block  a .fab,
#central-line-central-block  a .fa,
#central-line-central-block a .fab{
  color: #fff;
  font-size: 12px;
}
#first-line-central-block a:hover,
#central-line-central-block a:hover{
  background-color: var(--ButtonColor);

}
#first-line-central-block  a:hover .fa,
#first-line-central-block  a:hover .fab,
#central-line-central-block a:hover .fa,
#central-line-central-block a:hover .fab{
  color: var(--ButtonTextHover);
}
#container_img{
  height: 64px;
  width: 150px;
}
#container_img a{
  height: 100%;
  display: flex;
  align-items: center;
  width: 100%;
}
.navbar-brand{
  min-height: 80px;
}
#logo-header{
  max-height: 100%;
  max-width: 100%;
}
.head_nav_outsideContainerImg{
  width: 100%;
  padding-bottom: 75%;
  position: relative;
}
.head_nav_containerImg{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  margin: 5px;
}
.head_nav_image {
  height: 100%;
  width: 100%;
  min-width: 100%;
  object-fit: cover;
}
.row-container-item-header > *{
  padding-left: 0;
  margin-right: 5px;
}
#scc-navbar{
  display: flex;
  align-items: flex-end;
}
#scc-navbar button{
  color: #5d5d5d;;
  border: 1px solid;
  width: 45px;
  height: 45px;
}
#central-button-header-block{
  /*  display: none; */
  height: 1px;
  z-index: 10;
  position: absolute;
  top: calc(50% - 21px);
  left: calc(50% - 116px);
  display: block;
}
#central-button-header-block button{
  background-color: #fff;
}
#central-button-header-block button:hover,
#central-button-header-block button:active{
  color: #fff;
  background-color: #c9c76d;
  border-color: #c9c76d;
}
#btn-schedule{
  display: flex;
}
#central-line-central-block{
  display: none;
}
#navbarText ul{
  margin-left: auto;
  margin-right: 0;
  display: flex;
  align-items: flex-end;
  padding: 5px 0 0 0;
  background-color: #fff;
}
@media (max-width: 1199.98px) {
  #btn-schedule{
    display:none;
  }
  #central-button-header-block{
    top: 50px!important;
  }
  #central-line-central-block{
    display:flex;
    justify-content: center;
    align-items: baseline;
    width: 216px;

  }
  #central-line-central-block a {
    width: 26px;
    height: 26px;
    border-radius: 13px;
  }
  #first-line-central-block {
    display:none;
  }
  #navbarText ul{
    align-items: center;
    margin-left: initial
  }
}
@media (max-width: 991.98px) {
  #first-line-right-block {
    width: auto;
  }
  #first-line-left-block{
    width: auto;
  }
  #central-line-central-block{
    display: none;
  }
  #scc-navbar{
    align-items: center;
  }
  #header-address-block-address{
    display: none;
  }
}
@media (max-width: 575.98px) {
  #first-line-left-block {
    display: none;
  }
  .span-header-phone{
    display: none;
  }
  #first-line-header {
    justify-content: center;
  }
}


</style>
